import { defineStore } from "pinia";
import { fetchSurveyInbox, listManageableSurveys, } from "@/services/surveyService";
import { isSurveyInboxActionablePending } from "@/types/survey";
export const useSurveyStore = defineStore("survey", {
    state: () => ({
        manageableSurveys: [],
        inbox: [],
        pendingCount: 0,
        requiredPendingCount: 0,
        loading: false,
        inboxLoading: false,
        error: "",
        lastLoadedAt: null,
        lastInboxAt: null,
    }),
    getters: {
        pendingInbox: (state) => state.inbox.filter((i) => isSurveyInboxActionablePending(i)),
    },
    actions: {
        async loadManageable(schoolId, opts) {
            if (!schoolId) {
                this.manageableSurveys = [];
                this.error = "Falta schoolId";
                return;
            }
            this.loading = true;
            this.error = "";
            try {
                this.manageableSurveys = await listManageableSurveys({
                    schoolId,
                    courseCode: opts?.courseCode,
                    year: opts?.year,
                });
                this.lastLoadedAt = new Date().toISOString();
            }
            catch (e) {
                const err = e;
                this.error =
                    err?.response?.data?.error?.message ||
                        err?.response?.data?.detail ||
                        err?.message ||
                        "No se pudieron cargar las encuestas";
                this.manageableSurveys = [];
            }
            finally {
                this.loading = false;
            }
        },
        async loadInbox(schoolId) {
            if (!localStorage.getItem("authToken")) {
                this.inbox = [];
                this.pendingCount = 0;
                this.requiredPendingCount = 0;
                return;
            }
            this.inboxLoading = true;
            try {
                const result = await fetchSurveyInbox(schoolId ? { schoolId } : undefined);
                this.inbox = result.surveys;
                this.pendingCount = result.pendingCount;
                this.requiredPendingCount = result.requiredPendingCount;
                this.lastInboxAt = new Date().toISOString();
            }
            catch (e) {
                console.warn("No se pudo cargar bandeja de encuestas", e);
                this.inbox = [];
                this.pendingCount = 0;
                this.requiredPendingCount = 0;
            }
            finally {
                this.inboxLoading = false;
            }
        },
        clear() {
            this.manageableSurveys = [];
            this.inbox = [];
            this.pendingCount = 0;
            this.requiredPendingCount = 0;
            this.loading = false;
            this.inboxLoading = false;
            this.error = "";
            this.lastLoadedAt = null;
            this.lastInboxAt = null;
        },
    },
});
